import Api from '@/services/Api'

export default {
  getToken (params, type) {
    if (type === 'facebook') {
      return Api().post('auth/facebook', params)
    } else if (type === 'google') {
      return Api().post('auth/google', params)
    } else if (type === 'wca') {
      return Api().get('auth/wca/token', {withCredentials: true, params}) // withCredentials required to pass cookies: https://codewithhugo.com/pass-cookies-axios-fetch-requests/
    } else {
      return null
    }
  },

  getSessionToken (params) {
    return Api().get('auth/auth_token', { params })
  },

  fetchSessions (params) {
    return Api().get('user/sessions', { params })
  },
  archiveSession (params) {
    return Api().put('user/archive', params)
  },

  donate (params) {
    return Api().put('donate/donate', params)
  }
}
